export const tableCellStyles = { padding: '20px 16px', border: 'none' }
